import { useEffect, useState } from "react";

interface RiskInstance {
  publishRiskData: () => Promise<string>;
  // Add other methods as needed
}

declare global {
  interface Window {
    Risk?: {
      create: (publicKey: string) => Promise<RiskInstance>;
    };
  }
}

export function useRiskJsLoader(publishableKey: string) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (typeof publishableKey !== "string" || publishableKey.length === 0) {
      return;
    }

    if (typeof window !== "undefined" && window.Risk) {
      setReady(true);
      return;
    }

    if (document.getElementById("risk-js")) return;

    const script = document.createElement("script");
    script.id = "risk-js";
    script.src = "https://risk.checkout.com/cdn/risk/3.3.0/risk.js";
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.integrity =
      "sha384-epdFZc/S1y08y2xiP6DM3+HlYwbsf7rF9Av491IHYaBS7tyY1JEcPWPE1JYLhauK";

    script.onload = () => setReady(true);
    script.onerror = () => setReady(false);

    document.body.appendChild(script);
  }, [publishableKey]);

  return ready;
}
